// Soi nhanh nguoi choi trong cua so duyet rut (owner 2026-10-06, khach "an vao id nguoi dung la ra thang trang kiem tra"):
// phan tinh toan thuan cua khoi soi nhanh, chi doc.

export type TienRow = { id: string; huong: 'nap' | 'rut'; so_tien: number; trang_thai: string; tao_luc: string; xu_ly_luc: string | null };
export type LanTien = { row: TienRow; luc: number };

// thoi gian SQLite (UTC, "YYYY-MM-DD HH:MM:SS") hoac ISO -> ms
export function msUtc(s: string | null | undefined): number {
  if (!s) return NaN;
  return Date.parse(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s) ? s.replace(' ', 'T') + 'Z' : s);
}

// rut con giu tien cua nguoi choi (da tru vi luc gui): dang cho, dang chi, da chi
const RUT_GIU = new Set(['cho', 'dang_tra', 'da_tra']);

// Lan nap da cong (luc cong) va lan rut gan nhat (luc gui: tien roi vi tu luc do), tru chinh lenh dang mo.
export function lanTienGanNhat(rows: TienRow[], boId: string): { nap: LanTien | null; rut: LanTien | null } {
  let nap: LanTien | null = null;
  let rut: LanTien | null = null;
  for (const row of rows) {
    if (row.id === boId) continue;
    if (row.huong === 'nap' && row.trang_thai === 'da_duyet') {
      const luc = msUtc(row.xu_ly_luc ?? row.tao_luc);
      if (Number.isFinite(luc) && (!nap || luc > nap.luc)) nap = { row, luc };
    } else if (row.huong === 'rut' && RUT_GIU.has(row.trang_thai)) {
      const luc = msUtc(row.tao_luc);
      if (Number.isFinite(luc) && (!rut || luc > rut.luc)) rut = { row, luc };
    }
  }
  return { nap, rut };
}

// Moc xem lich su choi: lan nap / rut gan nhat; khong co thi null (xem cac van moi nhat)
export function mocTien(l: { nap: LanTien | null; rut: LanTien | null }): number | null {
  const m = Math.max(l.nap?.luc ?? -Infinity, l.rut?.luc ?? -Infinity);
  return Number.isFinite(m) ? m : null;
}

// n van moi nhat dat tu moc tro di (danh sach API da xep moi nhat truoc)
export function cuocTuMoc<T extends { created_time: number }>(bets: T[], moc: number | null, n = 20): T[] {
  return bets.filter((b) => moc === null || Number(b.created_time) >= moc).slice(0, n);
}

export type VongCuoc = { con_lai: number; nap: number; thuong: { con_lai: number; tong_yeu_cau: number } };

// vong cuoc thuong: da cuoc / tong yeu cau (vc_tong - vc_can / vc_tong); con phai cuoc truoc khi rut va vong cuoc nap con lai
export function vongCuocDaCan(w: VongCuoc): { da: number; can: number; conLai: number; napCon: number } {
  const can = Math.max(0, Number(w.thuong.tong_yeu_cau) || 0);
  return { da: Math.max(0, can - (Number(w.thuong.con_lai) || 0)), can, conLai: Number(w.con_lai) || 0, napCon: Number(w.nap) || 0 };
}
